import { View, ViewProps } from '@shared/components/View';
import { LoadingIndicator } from '@shared/components/loading';
import styles from './MenuLoading.module.css';

/**
 * Menu.Loading
 *
 * The spinner a menu shows while its rows are fetched. Reserves enough height that the menu keeps
 * its shape instead of collapsing to a sliver mid-fetch. `Menu.Options` renders this itself when
 * passed `loading`; use it directly in a menu that keeps its own list.
 */

type MenuLoadingProps = ViewProps;

export function MenuLoading({ className, ...rest }: MenuLoadingProps) {
  return (
    <View center className={[styles.menuLoading, className]} {...rest}>
      <LoadingIndicator />
    </View>
  );
}
